import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {reserveHistoryRoute} from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { TextInput } from '../../components/common/components'
import { setHistoryResult, searchHistory, cancelReserve } from '../../actions'
import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import {weeks} from '../../utils/utils'



export default function HistoryResult() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveHistoryRoute, (o) => o.path === location.pathname)

    const result = (useSelector(state => state.getIn(["reserveHistory", "result"]))).toJS()

    useEffect(() => {
        if(_.isEmpty(result)){
            Swal.fire("無查詢結果", "", "info")
            history.push('/search')
        }
        return () => {
           dispatch(setHistoryResult({value:{}}))
        }
    }, [])



    const dispatch = useDispatch()

    let history = useHistory();

    const handleNextClick = () => {       
       
    }

    return <Box className={layoutClasses.page}>        
        <Helmet>
            <title>{reserveHistoryRoute[idx].name}</title>
        </Helmet>
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveHistoryRoute[idx].name}
            </Typography>  
            <Typography variant="body1" gutterBottom>
                預約代號：{result.TICKET_NO}
            </Typography>
            <Typography variant="body1" gutterBottom>
                身分證字號：{result.PAT_IDNO}
            </Typography>
            <Typography variant="body1" gutterBottom>
                聯絡電話：{result.TEL_MOBILE}
            </Typography>
            <Typography variant="body1" gutterBottom>
                電子郵件：{result.EMAIL}
            </Typography>
            <Typography variant="body1" gutterBottom>
                預約日期：{result.SCHD_DATE_STR}({weeks[result.DAYS_STR]})
            </Typography>
            <Typography variant="body1" gutterBottom>
                預約時段：{result.SCHD_TIME_STR}
            </Typography>
        </Paper>
        <Button
            variant="contained"
            color="primary"
            style={{ margin: "30px" }}
            onClick={() => {history.push('/search')}}
        >
            回查詢頁
        </Button>
        <Button
            variant="contained"            
            style={{ margin: "30px" }}
            onClick={() => { dispatch(cancelReserve()) }}
        >
            取消預約
        </Button>
    </Box>
}